import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, vModelText as _vModelText, mergeProps as _mergeProps, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-8 flex justify-center"
}
const _hoisted_2 = {
  key: 1,
  class: "p-6 text-center text-red-600"
}
const _hoisted_3 = {
  key: 2,
  class: "p-6 grid grid-cols-2 gap-4"
}
const _hoisted_4 = { class: "col-span-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_7 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_9 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_10 = { class: "col-span-2" }
const _hoisted_11 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_12 = { class: "col-span-2" }
const _hoisted_13 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}

import { ref, watch, computed } from "vue";
import { useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/yup";
import * as yup from "yup";
import AdminModalShell from "@/share/components/admin/AdminModalShell.vue";
import AdminModalHeader from "@/share/components/admin/AdminModalHeader.vue";
import AdminModalFooter from "@/share/components/admin/AdminModalFooter.vue";
import AdminButton from "@/share/components/admin/AdminButton.vue";
import type { ProveedorCreateInterface } from "../../interfaces/proveedorInterfaces/ProveedorCreate.interface";
import { useProveedorFindOne } from "../../composables/proveedorCoposables";
import { useListListaOpciones } from "@/utils/listaopciones/composes/useListListaOpciones";

interface Props {
  isOpen: boolean;
  proveedorId?: string;
  isSaving?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FormularioProveedor',
  props: {
    isOpen: { type: Boolean },
    proveedorId: {},
    isSaving: { type: Boolean, default: false }
  },
  emits: ["close", "save", "update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { opciones } = useListListaOpciones(ref("TipoDocumento"));

const schema = toTypedSchema(
  yup.object({
    nombreProveedor: yup
      .string()
      .required("El nombre es obligatorio")
      .trim()
      .min(3, "Debe tener al menos 3 caracteres"),
    documentoProveedor: yup
      .string()
      .required("El documento es obligatorio")
      .matches(/^[0-9]{8,15}$/, "El documento debe contener entre 8 y 15 dígitos"),
    idTipoDocumento: yup.string().required("Selecciona un tipo de documento"),
    correoProveedor: yup
      .string()
      .optional()
      .transform((v) => (v == null ? "" : String(v)).trim())
      .test(
        "correo",
        "Correo electrónico inválido",
        (val) => !val || /^[\w.\\-]+@([\w-]+\.)+[\w-]{2,4}$/.test(val)
      ),
    telefonoProveedor: yup
      .string()
      .required("El teléfono es obligatorio")
      .matches(/^[0-9]{6,15}$/, "El teléfono debe tener entre 6 y 15 dígitos"),
    direccionProveedor: yup
      .string()
      .optional()
      .transform((v) => (v == null ? "" : String(v)).trim())
      .max(200, "La dirección no puede exceder 200 caracteres")
      .test(
        "dir-min",
        "La dirección debe de tener minimo 5 caracteres",
        (val) => !val || val.trim().length >= 5
      ),
    descripcionProveedor: yup
      .string()
      .optional()
      .transform((v) => (v == null ? "" : String(v)).trim())
      .max(300, "La descripción no puede exceder 300 caracteres"),
  })
);

const { defineField, errors, handleSubmit, meta, resetForm, setValues } =
  useForm({
    validationSchema: schema,
    initialValues: {
      nombreProveedor: "",
      documentoProveedor: "",
      idTipoDocumento: "",
      correoProveedor: "",
      telefonoProveedor: "",
      direccionProveedor: "",
      descripcionProveedor: "",
    },
  });

const [nombreProveedor, nombreProveedorAttrs] = defineField("nombreProveedor");
const [documentoProveedor, documentoProveedorAttrs] =
  defineField("documentoProveedor");
const [idTipoDocumento, idTipoDocumentoAttrs] = defineField("idTipoDocumento");
const [correoProveedor, correoProveedorAttrs] = defineField("correoProveedor");
const [telefonoProveedor, telefonoProveedorAttrs] =
  defineField("telefonoProveedor");
const [direccionProveedor, direccionProveedorAttrs] =
  defineField("direccionProveedor");
const [descripcionProveedor, descripcionProveedorAttrs] =
  defineField("descripcionProveedor");

const proveedorIdRef = computed(() => props.proveedorId || "");
const {
  data: proveedorData,
  isPending,
  isError,
} = useProveedorFindOne(proveedorIdRef);
const isEditMode = computed(() => !!props.proveedorId);

watch(
  proveedorData,
  (newData) => {
    const proveedor = newData?.data?.data;
    if (proveedor && typeof proveedor === "object") {
      setValues({
        nombreProveedor: proveedor.nombreProveedor || "",
        documentoProveedor: proveedor.documentoProveedor || "",
        idTipoDocumento: proveedor.idTipoDocumento || "",
        correoProveedor: proveedor.correoProveedor || "",
        telefonoProveedor: proveedor.telefonoProveedor || "",
        direccionProveedor: proveedor.direccionProveedor || "",
        descripcionProveedor: proveedor.descripcionProveedor || "",
      });
    }
  },
  { immediate: true, deep: true }
);

watch(
  () => props.isOpen,
  (isOpen) => {
    if (!isOpen && !isEditMode.value) limpiarCampos();
  }
);

function limpiarCampos() {
  resetForm({
    values: {
      nombreProveedor: "",
      documentoProveedor: "",
      idTipoDocumento: "",
      correoProveedor: "",
      telefonoProveedor: "",
      direccionProveedor: "",
      descripcionProveedor: "",
    },
  });
}

const handleSave = handleSubmit((vals) => {
  const proveedor: ProveedorCreateInterface = {
    nombreProveedor: vals.nombreProveedor.trim(),
    documentoProveedor: vals.documentoProveedor.trim(),
    idTipoDocumento: vals.idTipoDocumento,
    correoProveedor: vals.correoProveedor.trim(),
    telefonoProveedor: vals.telefonoProveedor.trim(),
    direccionProveedor: vals.direccionProveedor.trim(),
    descripcionProveedor: vals.descripcionProveedor.trim(),
  };

  if (isEditMode.value && props.proveedorId) {
    emit("update", props.proveedorId, proveedor);
  } else {
    emit("save", proveedor);
  }
});

const handleClose = () => {
  limpiarCampos();
  emit("close");
};

const opcionesTipoDocumento = computed(() => {
  return (
    opciones.value?.map((opcion) => ({
      value: opcion.id,
      label: opcion.nombre,
    })) || []
  );
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40 flex items-center justify-center p-4",
            onClick: _withModifiers(handleClose, ["self"])
          }, [
            _createVNode(_Transition, { name: "scale" }, {
              default: _withCtx(() => [
                (__props.isOpen)
                  ? (_openBlock(), _createBlock(AdminModalShell, {
                      key: 0,
                      "max-width-class": "max-w-2xl"
                    }, {
                      header: _withCtx(() => [
                        _createVNode(AdminModalHeader, {
                          variant: "dark",
                          title: isEditMode.value ? 'Editar Proveedor' : 'Nuevo Proveedor',
                          onClose: handleClose
                        }, {
                          icon: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("svg", {
                              class: "w-7 h-7",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                              })
                            ], -1)
                          ]))]),
                          _: 1
                        }, 8, ["title"])
                      ]),
                      footer: _withCtx(() => [
                        _createVNode(AdminModalFooter, { "rounded-bottom": "" }, {
                          default: _withCtx(() => [
                            _createVNode(AdminButton, {
                              variant: "secondary",
                              onClick: handleClose
                            }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createTextVNode(" Cancelar ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(AdminButton, {
                              variant: "info",
                              disabled: !_unref(meta).valid || (_unref(isPending) && isEditMode.value) || props.isSaving,
                              loading: props.isSaving,
                              onClick: _unref(handleSave)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.isSaving
                    ? "Guardando…"
                    : isEditMode.value
                      ? "Actualizar"
                      : "Guardar"), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading", "onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_unref(isPending) && isEditMode.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[8] || (_cache[8] = [
                              _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-red-600" }, null, -1)
                            ]))]))
                          : (_unref(isError) && isEditMode.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Error al cargar el proveedor "))
                            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "font-semibold text-slate-700" }, [
                                    _createTextVNode(" Nombre del Proveedor "),
                                    _createElementVNode("span", { class: "text-red-500" }, "*")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("input", _mergeProps({
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(nombreProveedor) ? (nombreProveedor).value = $event : null))
                                  }, _unref(nombreProveedorAttrs), {
                                    type: "text",
                                    placeholder: "Ej: Distribuidora San José",
                                    maxlength: "100",
                                    class: ["w-full px-4 py-3 border-2 rounded-xl outline-none transition-all", 
                  _unref(errors).nombreProveedor
                    ? 'border-red-300 focus:border-red-500'
                    : 'border-slate-200 focus:border-blue-500'
                ]
                                  }), null, 16), [
                                    [_vModelText, _unref(nombreProveedor)]
                                  ]),
                                  (_unref(errors).nombreProveedor)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(errors).nombreProveedor), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "font-semibold text-slate-700" }, [
                                    _createTextVNode(" Documento "),
                                    _createElementVNode("span", { class: "text-red-500" }, "*")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("input", _mergeProps({
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(documentoProveedor) ? (documentoProveedor).value = $event : null))
                                  }, _unref(documentoProveedorAttrs), {
                                    type: "text",
                                    placeholder: "RUC o DNI",
                                    maxlength: "15",
                                    class: ["w-full px-4 py-3 border-2 rounded-xl outline-none transition-all", 
                  _unref(errors).documentoProveedor
                    ? 'border-red-300 focus:border-red-500'
                    : 'border-slate-200 focus:border-blue-500'
                ]
                                  }), null, 16), [
                                    [_vModelText, _unref(documentoProveedor)]
                                  ]),
                                  (_unref(errors).documentoProveedor)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(errors).documentoProveedor), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block text-sm font-semibold text-slate-700 mb-2" }, [
                                    _createTextVNode(" Tipo de Documento "),
                                    _createElementVNode("span", { class: "text-red-500" }, "*")
                                  ], -1)),
                                  _createVNode(_component_v_select, _mergeProps({
                                    modelValue: _unref(idTipoDocumento),
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(idTipoDocumento) ? (idTipoDocumento).value = $event : null))
                                  }, _unref(idTipoDocumentoAttrs), {
                                    options: opcionesTipoDocumento.value,
                                    reduce: (option) => option.value,
                                    label: "label",
                                    placeholder: "Selecciona...",
                                    "append-to-body": true,
                                    class: ["custom-v-select", _unref(errors).idTipoDocumento ? 'border-red-400' : '']
                                  }), null, 16, ["modelValue", "options", "reduce", "class"]),
                                  (_unref(errors).idTipoDocumento)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(errors).idTipoDocumento), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "font-semibold text-slate-700" }, [
                                    _createTextVNode(" Correo electrónico "),
                                    _createElementVNode("span", { class: "text-slate-400 font-normal text-xs" }, "(opcional)")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("input", _mergeProps({
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(correoProveedor) ? (correoProveedor).value = $event : null))
                                  }, _unref(correoProveedorAttrs), {
                                    type: "email",
                                    placeholder: "ejemplo@correo.com",
                                    class: ["w-full px-4 py-3 border-2 rounded-xl outline-none transition-all", 
                  _unref(errors).correoProveedor
                    ? 'border-red-300 focus:border-red-500'
                    : 'border-slate-200 focus:border-blue-500'
                ]
                                  }), null, 16), [
                                    [_vModelText, _unref(correoProveedor)]
                                  ]),
                                  (_unref(errors).correoProveedor)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(errors).correoProveedor), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "font-semibold text-slate-700" }, [
                                    _createTextVNode(" Teléfono "),
                                    _createElementVNode("span", { class: "text-red-500" }, "*")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("input", _mergeProps({
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(telefonoProveedor) ? (telefonoProveedor).value = $event : null))
                                  }, _unref(telefonoProveedorAttrs), {
                                    type: "text",
                                    placeholder: "Ej: 987654321",
                                    class: ["w-full px-4 py-3 border-2 rounded-xl outline-none transition-all", 
                  _unref(errors).telefonoProveedor
                    ? 'border-red-300 focus:border-red-500'
                    : 'border-slate-200 focus:border-blue-500'
                ]
                                  }), null, 16), [
                                    [_vModelText, _unref(telefonoProveedor)]
                                  ]),
                                  (_unref(errors).telefonoProveedor)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(errors).telefonoProveedor), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "font-semibold text-slate-700" }, [
                                    _createTextVNode(" Dirección "),
                                    _createElementVNode("span", { class: "text-slate-400 font-normal text-xs" }, "(opcional)")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("input", _mergeProps({
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(direccionProveedor) ? (direccionProveedor).value = $event : null))
                                  }, _unref(direccionProveedorAttrs), {
                                    type: "text",
                                    placeholder: "Ej: Av. Los Álamos 123",
                                    class: ["w-full px-4 py-3 border-2 rounded-xl outline-none transition-all", 
                  _unref(errors).direccionProveedor
                    ? 'border-red-300 focus:border-red-500'
                    : 'border-slate-200 focus:border-blue-500'
                ]
                                  }), null, 16), [
                                    [_vModelText, _unref(direccionProveedor)]
                                  ]),
                                  (_unref(errors).direccionProveedor)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_unref(errors).direccionProveedor), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "font-semibold text-slate-700" }, [
                                    _createTextVNode(" Descripción "),
                                    _createElementVNode("span", { class: "text-slate-400 font-normal text-xs" }, "(opcional)")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("textarea", _mergeProps({
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(descripcionProveedor) ? (descripcionProveedor).value = $event : null))
                                  }, _unref(descripcionProveedorAttrs), {
                                    rows: "4",
                                    placeholder: "Información adicional sobre el proveedor",
                                    class: ["w-full px-4 py-3 border-2 rounded-xl outline-none transition-all resize-none", 
                  _unref(errors).descripcionProveedor
                    ? 'border-red-300 focus:border-red-500'
                    : 'border-slate-200 focus:border-blue-500'
                ]
                                  }), null, 16), [
                                    [_vModelText, _unref(descripcionProveedor)]
                                  ]),
                                  (_unref(errors).descripcionProveedor)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(errors).descripcionProveedor), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})